import { Component, OnInit } from '@angular/core'
import { UserService } from '@service/user/user.service'

@Component({
  selector: 'profile-statistics',
  templateUrl: './profile-statistics.component.html',
  styleUrls: ['./profile-statistics.component.scss'],
})
export class ProfileStatisticsComponent implements OnInit {
  public statistics: any = []
  public objectKeys = Object.keys

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.userObservable.subscribe(user => {
      this.statistics = []

      if (user) {
        for (const key of Object.keys(user)) {
          if (key.startsWith('statistics_')) {
            this.statistics[key] = user[key]
          }
        }
      }
    })
  }
}
